import React from "react";
import { useTranslation } from "react-i18next";
import SectionHeading from "@/app/pages/industryAnalysis/SectionHeading";
import { Link } from "react-router-dom";

const MoversAndShakers = ({moversAndShakersData}) => {
  const { t } = useTranslation();
  const heading = t("industryAnalysis.moversAndShakers.heading");
  const moversAndShakers = moversAndShakersData.map(data => JSON.parse(data));

  return (
    <>
      <div className="moversAndShakersWrapper">
        <div className="container">
          <a className="anchor" name="movers_and_shakers_anchor"></a>

          <SectionHeading heading={heading} />
          <div className="moverShakerContainer">
          {moversAndShakers && moversAndShakers.length && moversAndShakers.slice(0, Math.min(Number(t("industryAnalysis.moversAndShakers.limit")), moversAndShakers.length)).map(moverAndShaker => <div className="row data margin-l-0 pad-l-0">
            <div className="item col-md-12 pad-l-0">
              <span className="country">
                {moverAndShaker.mostSnrPrincipal} {""}
                <Link className="sideLink" to={`/business-directory/company-profiles.${moverAndShaker['primaryNameForUrl']}.${moverAndShaker['duns']}.html`}>
                 {" at "}  {moverAndShaker.primaryName}
                </Link>
              </span>
            </div>
          </div>)}
          </div>
        </div>
      </div>
    </>
  );
};

export default MoversAndShakers;
